export function favorite(state){
    return state.favorite
}

export function progress(state){
    return state.progress
}

export function search(state){
    return state.search
}

export function selected_areas(state){
    return state.selected_areas
}

export function playlist(state){
    return state.playlist
}

export function selected_groups(state){
    return state.selected_groups
}

export function selected_tags(state){
    return state.selected_tags
}

export function origin(state){
    return state.origin
}

export function trail_id(state){
    return state.trail_id
}

export function loading(state){
    return state.loading
}

export function podcast_id(state){
    return state.podcast_id
}